import { storeToRefs } from 'pinia'
import { nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import { useContentful } from '@/components/common/contentful/composables/useContentful'

import { useAppStore } from '@/stores/app'

export function useNavigation(refs) {
  const router = useRouter()
  const route = useRoute()
  const appStore = useAppStore()
  const { previousRoute } = storeToRefs(appStore)
  const contentful = useContentful()

  const anchorTo = (refName) => {
    if (!refName) return

    if (refs && refs[refName]) {
      const element = refs[refName]
      if (element && element.length) {
        window.scrollTo({
          top: element[0].offsetTop,
          behavior: 'smooth',
        })
      }
      return
    }

    if (typeof refName === 'string') {
      const el = document.getElementById(refName)
      if (el) {
        window.scrollTo({
          top: el.offsetTop,
          behavior: 'smooth',
        })
      }
      return
    }

    if (refName.value) {
      const el = refName.value
      if (el) {
        window.scrollTo({
          top: el.offsetTop,
          behavior: 'smooth',
        })
      }
    }
  }

  const scrollIntoEl = (refName) => {
    if (!refName) return

    if (refs && refs[refName]) {
      const element = refs[refName]
      if (element && element.length) {
        element[0].$el.scrollIntoView()
      }
      return
    }

    if (typeof refName === 'string') {
      const el = document.getElementById(refName)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
      return
    }

    if (refName.value) {
      const el = refName.value
      if (el) {
        if (el.$el) {
          el.$el.scrollIntoView({ behavior: 'smooth' })
        } else {
          el.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }

  const anchorToEntry = (arr) => {
    if (arr && arr.length) {
      nextTick(() => {
        const item = arr.find((el) => el.title.trim() === route.query.entry)
        setTimeout(() => anchorTo(item?.title), 1000)
      })
    }
  }

  const navigateTo = (link, target = '_self', onItemClicked) => {
    const redirect = contentful.service.getRedirect(link)
    const navigateToUrl = redirect || link
    const isWindowNavigation =
      redirect || target === '_blank' || link.includes('blog.bioivt.com') || link.startsWith('http')
    if (isWindowNavigation) {
      const link = document.createElement('a')
      link.href = navigateToUrl
      link.target = target
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else {
      router.push(navigateToUrl)
    }
    if (onItemClicked) onItemClicked()
  }

  const goBack = () => {
    router.push(previousRoute.value.fullPath || '/')
  }

  return {
    anchorTo,
    scrollIntoEl,
    anchorToEntry,
    navigateTo,
    goBack,
  }
}
